import React from 'react';
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import {Container, Row} from 'react-bootstrap';
import 'simplebar-react/dist/simplebar.min.css';
import CloseIconSearch from '../nzuac-svg/CloseIconSearch';
import NZUACModalFormTwo from './NZUACModalFormTwo';



const Popup = ({
  show,
  handleClose,
  no_img,
  item,
  title,
  description,
  data,
  subtitle,
  img
}) => {


  return (

    <StyledModal>
      <Modal
        show={show}
        item={item}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        className="gph_modal landing-page-modal popup-version-one c form-modal form-modal"
      >

        <Modal.Body>

          <Container className={'close-icon-modal'} style={{height:0}}>
            <Row className={'for-close'} onClick={handleClose}>
              <div className="modal-close ">
                <CloseIconSearch/>
              </div>
            </Row>
          </Container>
          <Container>
            <Row className={'m-0 heightOk'}>
              <div className="modal-data d-flex">
                <NZUACModalFormTwo pt={'100'}/>
              </div>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </StyledModal>

  );
};


const StyledModal = styled.section`
    background-color: #F5F5F5;

    .modal-dialog {
        max-width: 100% !important;
    }

    h4 {
        letter-spacing: 1.5px;
    }


`;


export default Popup;
